import React from "react";
import * as s from "./index.module.scss";
import CustomerService from "../../images/FreeAppraisal/customer-service.svg";
import { PrismicRichText } from "@prismicio/react";
import secondaryFont from "@/utils/secondaryFont";

const WorkingHours = ({ data }) => {
  return (
    <div className={s.working_hours}>
      <h3 className="heading fw-bold">{data?.title || ""}</h3>
      {/* <p>
            Visit us at our office or give us a call to discuss your requirement
        </p> */}
      <div className={`${secondaryFont} title`}>
        <PrismicRichText field={data?.desc || []} />
      </div>
      <div className={s.working_hours_table}>
        {data?.days.map((item, idx) => {
          return (
            <React.Fragment key={idx}>
              <div className={`${secondaryFont}`}>
                <h6 className="title fw-bold">{item?.day}</h6>
                <h6 className="sub-title">{item?.time}</h6>
              </div>
            </React.Fragment>
          );
        })}
      </div>

      <div
        className={`d-flex align-items-center justify-content-between ${s.speak_with_expert}`}
      >
        <div>
          <p className={`${secondaryFont}`}>{data?.call_caption}</p>
          <h5 className="fw-bold">{data?.call_title}</h5>
        </div>
        <div className="d-flex align-items-center">
          <img
            loading="lazy"
            src={CustomerService.src}
            alt="image"
            height="100%"
          />
          <div className={`${secondaryFont}`}>
            <a
              href={`tel:${
                data?.call_number ? data.call_number.replace(/\s/g, "") : ""
              }`}
            >
              {data?.call_number}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkingHours;
